import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueTheMask from 'vue-the-mask'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import VueCookies from 'vue-js-cookie'
import 'vueperslides/dist/vueperslides.css'
import VueCookie from 'vue-cookie'

Vue.component('LazyComponent', () => import('@/pages/index.vue'))

Vue.use(VueCookie)
Vue.use(VueCookies)
Vue.use(VueTheMask)
Vue.use(VueDOMPurifyHTML)

const options = {
  position: 'top-center',
}
Vue.use(Toast, options)

Vue.mixin({
  computed: {
    gradientBackground() {
      const theme = this.$vuetify.theme
      const gradient = theme.isDark
        ? theme.themes.dark.gradient
        : theme.themes.light.gradient

      return `linear-gradient(to right, ${gradient.gradientDefault1}, ${gradient.gradientDefault2})`
    },
    colorBody() {
      const theme = this.$vuetify.theme
      return theme.isDark ? theme.themes.dark.body : theme.themes.light.body
    },
  },
})
